import React, { CSSProperties, ReactElement } from 'react';
import { Divider, DividerContainer } from './HBDivider.styles';
import { vars } from '../../theme';

export interface Props {
    /** Label element rendered at the left edge of the divider line; uses a surface.container background overlay to visually break the line. */
    children?: ReactElement;
    /** Renders the divider as a dashed line instead of solid. */
    dashed?: boolean;
    /** Line color. Defaults to stroke.secondary. */
    color?: string;
    /** CSS class forwarded to the outer wrapper element. */
    className?: string;
    /** CSS margin applied to the outer wrapper. */
    margin?: string;
    /** CSS padding applied to the outer wrapper. */
    padding?: CSSProperties['padding'];
}

const HBDivider = ({
    children,
    dashed = false,
    color = vars.colors.stroke.secondary,
    margin = '',
    padding,
    className
}: Props) => {
    return (
        <DividerContainer
            margin={margin}
            $padding={padding}
            className={className}
        >
            <Divider color={color} dashed={dashed}>
                {children && <span>{children}</span>}
            </Divider>
        </DividerContainer>
    );
};

export default HBDivider;
